import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import * as FirestoreService from '../services/firestore';

import AppContext from '../hooks/AppContext'
import React, { useLayoutEffect, useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useParams, useNavigate, useLocation} from 'react-router-dom';
import PATH from '../utils/Paths';

const Login = () => {

    const { user,setUser, setLoading} = useContext(AppContext);  
    const { urlInstancia } = useParams()
    
    const navigate = useNavigate();
    const location = useLocation();

    const[email,setEmail] = useState();
    const[senha,setSenha] = useState();

    const allowEnter = () => {

        let navTo = PATH.VOTACAO 
        if(urlInstancia){
            navTo = navTo + "/" + urlInstancia            
        }
        if(location?.state?.origin){
            navTo = location?.state?.origin               
        }
        
        navigate(navTo ,{search: location?.state?.search || ""})
    }

    const loginGoogle= () =>{
        FirestoreService.loginComGooglePopUp(setUser).then(result => {            
            //entra na aplicação
            allowEnter()

        }).catch((error)=>{
            console.error(error)            
            alert("Não foi possível logar")
        })
    }

    const loginEmail= () =>{
        FirestoreService.login(email,senha,setUser).then(result => {
            //entra na aplicação
            allowEnter()
        
        }).catch((error)=>{
            console.error(error)            
            alert("Não foi possível logar")            
        })
    }

    useEffect(()=>{        
        //Se usuario logado
        if(user){
            //entra na aplicação
            setTimeout(()=>allowEnter(),500)            
        }else{
            //preserva a urlinstancia
            if(urlInstancia){           
                setTimeout(()=>
                    navigate({
                    pathname: PATH.LOGIN + "/" + urlInstancia,        
                    replace: true, 
                    search: location?.state?.search
                    })
                ,100)
            }
            setLoading(false)           
        }
    },[])

    if(user){
        return null
    }
    return (  
        <div className="layout-main app-layout-main flex-column justify-content-center w-full">
            <div className="flex align-items-center justify-content-center">
                <div className="surface-card p-4 shadow-2 login-context w-full bloco-dados lg:w-5">
                    <div className="bloco-title align-self-center text-center mb-5">                    
                        <div className="mb-3">Login</div>
                    </div>

                    <div>
                        <label htmlFor="email" className="block mb-2">Email</label>
                        <InputText onChange={(e) => setEmail(e.target.value)} id="email" type="text" className="w-full mb-3" />

                        <label htmlFor="password" className="block mb-2">Senha</label>
                        <InputText onChange={(e) => setSenha(e.target.value)} id="password" type="password" className="w-full mb-3" />          

                        <Button label="Entrar com Google" icon="pi pi-google" className="p-button-rounded w-full mb-3" onClick={loginGoogle}/>

                        <Button label="Entrar" icon="pi pi-user" className="p-button-rounded w-full p-button-success" onClick={loginEmail} />
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Login;
